import type { ModuleMigrationDef } from "@kubdee/sdk";

export const migration: ModuleMigrationDef = {
  key: "001_initial",
  version: "1.0.0",
  sql: `
CREATE TABLE IF NOT EXISTS \`car_rental_rental_locations\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`name\` text NOT NULL,
	\`address\` text,
	\`contact_phone\` text,
	\`is_active\` integer DEFAULT 1 NOT NULL,
	\`sort_order\` integer DEFAULT 0 NOT NULL,
	\`created_at\` text NOT NULL,
	\`created_by\` text,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text,
	\`deleted_at\` text,
	\`deleted_by\` text
);
CREATE TABLE IF NOT EXISTS \`car_rental_vehicles\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`fleet_vehicle_id\` text NOT NULL,
	\`calculation_method\` text DEFAULT '24_hour_cycle' NOT NULL,
	\`daily_cutoff_time\` text,
	\`daily_rate\` real DEFAULT 0 NOT NULL,
	\`hourly_rate\` real DEFAULT 0,
	\`security_deposit\` real DEFAULT 0,
	\`driver_rate_per_day\` real DEFAULT 0,
	\`has_driver\` integer DEFAULT 0 NOT NULL,
	\`late_fee_per_hour\` real DEFAULT 0,
	\`grace_period_hours\` integer DEFAULT 0,
	\`extra_day_threshold_hours\` integer DEFAULT 0,
	\`is_rented\` integer DEFAULT 0 NOT NULL,
	\`is_active\` integer DEFAULT 1 NOT NULL,
	\`created_at\` text NOT NULL,
	\`created_by\` text,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text,
	\`deleted_at\` text,
	\`deleted_by\` text,
	FOREIGN KEY (\`fleet_vehicle_id\`) REFERENCES \`fleet_vehicles\`(\`id\`) ON UPDATE no action ON DELETE no action
);
CREATE INDEX IF NOT EXISTS \`rv_company_active_idx\` ON \`car_rental_vehicles\` (\`company_id\`,\`is_active\`);
CREATE TABLE IF NOT EXISTS \`car_rental_vehicle_images\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`vehicle_id\` text NOT NULL,
	\`image_url\` text NOT NULL,
	\`caption\` text,
	\`sort_order\` integer DEFAULT 0 NOT NULL,
	\`created_at\` text NOT NULL,
	\`created_by\` text,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text,
	\`deleted_at\` text,
	\`deleted_by\` text,
	FOREIGN KEY (\`vehicle_id\`) REFERENCES \`car_rental_vehicles\`(\`id\`) ON UPDATE no action ON DELETE no action
);
CREATE TABLE IF NOT EXISTS \`car_rental_rental_bookings\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`booking_no\` text NOT NULL,
	\`company_id\` text NOT NULL,
	\`branch_id\` text,
	\`pickup_branch_id\` text,
	\`return_branch_id\` text,
	\`customer_id\` text NOT NULL,
	\`vehicle_id\` text NOT NULL,
	\`pickup_datetime\` text NOT NULL,
	\`return_datetime\` text NOT NULL,
	\`actual_return_datetime\` text,
	\`pickup_location\` text,
	\`return_location\` text,
	\`pickup_location_id\` text,
	\`return_location_id\` text,
	\`pickup_location_other\` text,
	\`return_location_other\` text,
	\`calculation_method\` text DEFAULT 'daily' NOT NULL,
	\`rental_days\` integer DEFAULT 1 NOT NULL,
	\`daily_rate\` real DEFAULT 0 NOT NULL,
	\`rental_amount\` real DEFAULT 0 NOT NULL,
	\`with_driver\` integer DEFAULT 0 NOT NULL,
	\`driver_rate_per_day\` real DEFAULT 0,
	\`total_driver_cost\` real DEFAULT 0,
	\`additional_charges\` real DEFAULT 0,
	\`additional_charges_json\` text,
	\`discount_amount\` real DEFAULT 0,
	\`discount_reason\` text,
	\`late_hours\` integer DEFAULT 0,
	\`late_fee_per_hour\` real DEFAULT 0,
	\`total_late_fee\` real DEFAULT 0,
	\`tax_template_id\` text,
	\`tax_type\` text DEFAULT 'no_tax' NOT NULL,
	\`tax_rate\` real DEFAULT 0,
	\`tax_amount\` real DEFAULT 0,
	\`security_deposit\` real DEFAULT 0,
	\`deposit_amount\` real DEFAULT 0,
	\`subtotal\` real DEFAULT 0 NOT NULL,
	\`grand_total\` real DEFAULT 0 NOT NULL,
	\`total_paid\` real DEFAULT 0 NOT NULL,
	\`outstanding_amount\` real DEFAULT 0 NOT NULL,
	\`total_penalty_amount\` real DEFAULT 0,
	\`refund_amount\` real DEFAULT 0,
	\`doc_status\` integer DEFAULT 0 NOT NULL,
	\`workflow_id\` text,
	\`current_state_key\` text,
	\`workflow_state\` text DEFAULT 'booked' NOT NULL,
	\`invoice_id\` text,
	\`deposit_payment_id\` text,
	\`balance_payment_id\` text,
	\`refund_payment_id\` text,
	\`release_id\` text,
	\`return_id\` text,
	\`remarks\` text,
	\`created_by\` text,
	\`created_at\` text NOT NULL,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text,
	\`deleted_at\` text,
	\`deleted_by\` text,
	FOREIGN KEY (\`vehicle_id\`) REFERENCES \`car_rental_vehicles\`(\`id\`) ON UPDATE no action ON DELETE no action,
	FOREIGN KEY (\`pickup_location_id\`) REFERENCES \`car_rental_rental_locations\`(\`id\`) ON UPDATE no action ON DELETE no action,
	FOREIGN KEY (\`return_location_id\`) REFERENCES \`car_rental_rental_locations\`(\`id\`) ON UPDATE no action ON DELETE no action
);
CREATE INDEX IF NOT EXISTS \`rb_company_state_idx\` ON \`car_rental_rental_bookings\` (\`company_id\`,\`workflow_state\`,\`created_at\`);
CREATE INDEX IF NOT EXISTS \`rb_company_customer_idx\` ON \`car_rental_rental_bookings\` (\`company_id\`,\`customer_id\`);
CREATE INDEX IF NOT EXISTS \`rb_company_vehicle_idx\` ON \`car_rental_rental_bookings\` (\`company_id\`,\`vehicle_id\`);
CREATE INDEX IF NOT EXISTS \`rb_company_pickup_idx\` ON \`car_rental_rental_bookings\` (\`company_id\`,\`pickup_datetime\`);
CREATE INDEX IF NOT EXISTS \`rb_company_pickup_branch_idx\` ON \`car_rental_rental_bookings\` (\`company_id\`,\`pickup_branch_id\`);
CREATE INDEX IF NOT EXISTS \`rb_company_return_branch_idx\` ON \`car_rental_rental_bookings\` (\`company_id\`,\`return_branch_id\`);
CREATE TABLE IF NOT EXISTS \`car_rental_rental_releases\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`release_no\` text NOT NULL,
	\`booking_id\` text NOT NULL,
	\`release_datetime\` text NOT NULL,
	\`released_by\` text,
	\`mileage_out\` real,
	\`fuel_level_out\` text,
	\`vehicle_condition\` text,
	\`existing_damage_notes\` text,
	\`release_remarks\` text,
	\`status\` text DEFAULT 'submitted' NOT NULL,
	\`created_at\` text NOT NULL,
	\`created_by\` text,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text,
	\`deleted_at\` text,
	\`deleted_by\` text,
	FOREIGN KEY (\`booking_id\`) REFERENCES \`car_rental_rental_bookings\`(\`id\`) ON UPDATE no action ON DELETE no action
);
CREATE UNIQUE INDEX IF NOT EXISTS \`rental_releases_release_no_unique\` ON \`car_rental_rental_releases\` (\`release_no\`);
CREATE TABLE IF NOT EXISTS \`car_rental_rental_returns\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`return_no\` text NOT NULL,
	\`booking_id\` text NOT NULL,
	\`release_id\` text NOT NULL,
	\`return_datetime\` text NOT NULL,
	\`received_by\` text,
	\`returned_by\` text,
	\`odometer_reading\` real,
	\`fuel_level\` text,
	\`exterior_condition\` text,
	\`interior_condition\` text,
	\`total_penalty\` real DEFAULT 0 NOT NULL,
	\`penalty_remarks\` text,
	\`refund_amount\` real DEFAULT 0 NOT NULL,
	\`return_remarks\` text,
	\`status\` text DEFAULT 'submitted' NOT NULL,
	\`created_at\` text NOT NULL,
	\`created_by\` text,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text,
	\`deleted_at\` text,
	\`deleted_by\` text,
	FOREIGN KEY (\`booking_id\`) REFERENCES \`car_rental_rental_bookings\`(\`id\`) ON UPDATE no action ON DELETE no action,
	FOREIGN KEY (\`release_id\`) REFERENCES \`car_rental_rental_releases\`(\`id\`) ON UPDATE no action ON DELETE no action
);
CREATE UNIQUE INDEX IF NOT EXISTS \`rental_returns_return_no_unique\` ON \`car_rental_rental_returns\` (\`return_no\`);
CREATE TABLE IF NOT EXISTS \`car_rental_rental_penalties\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`return_id\` text NOT NULL,
	\`description\` text,
	\`amount\` real DEFAULT 0 NOT NULL,
	\`remarks\` text,
	\`created_at\` text NOT NULL,
	\`created_by\` text,
	FOREIGN KEY (\`return_id\`) REFERENCES \`car_rental_rental_returns\`(\`id\`) ON UPDATE no action ON DELETE no action
);
CREATE TABLE IF NOT EXISTS \`car_rental_rental_settings\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`workflow_type\` text DEFAULT 'standard' NOT NULL,
	\`default_calculation_method\` text DEFAULT '24_hour_cycle' NOT NULL,
	\`default_tax_type\` text DEFAULT 'no_tax' NOT NULL,
	\`default_tax_rate\` real DEFAULT 0 NOT NULL,
	\`default_tax_template_id\` text,
	\`default_deposit_amount\` text,
	\`default_daily_cutoff_time\` text,
	\`default_daily_rate\` real,
	\`default_hourly_rate\` real,
	\`default_security_deposit\` real,
	\`default_late_fee_per_hour\` real,
	\`default_grace_period_hours\` real,
	\`default_extra_day_threshold_hours\` real,
	\`default_driver_rate_per_day\` real,
	\`created_at\` text NOT NULL,
	\`created_by\` text,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text
);
CREATE UNIQUE INDEX IF NOT EXISTS \`rental_settings_company_id_unique\` ON \`car_rental_rental_settings\` (\`company_id\`);
  `.trim(),
};
